'use strict';

var React = require('react');
var index = require('./index-fccd5f88.js');
var injectGlobalCss = require('./injectGlobalCss-bc8cf911.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var css = ".Form_module_visuallyHidden__a0f9881c {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.Form_module_youtubeVideo__a0f9881c {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 16/9;\n  display: block;\n}\n\n.Form_module_Fieldset__a0f9881c {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n}";
injectGlobalCss.injectCss(css, "/opt/atlassian/pipelines/agent/build/src/stories/components/Atoms/Forms/Form/Form.module.scss");
var modules_b9bf355c = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1080px)","uiBreakWideScreenMin":"strip-units(1920px)","visuallyHidden":"Form_module_visuallyHidden__a0f9881c","youtubeVideo":"Form_module_youtubeVideo__a0f9881c","Fieldset":"Form_module_Fieldset__a0f9881c"};

var Form = function Form(props) {
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("form", {
    className: [modules_b9bf355c.Form, props.extraClass].join(" "),
    name: props.formName,
    method: props.method,
    target: props.target,
    rel: props.rel,
    autoComplete: props.autoComplete,
    action: props.formAction
  }, props.children));
};
Form.propTypes = {
  extraClass: index.propTypes.exports.string,
  formName: index.propTypes.exports.string,
  method: index.propTypes.exports.string,
  target: index.propTypes.exports.oneOf(['_blank', '_self', '_parent', '_top']),
  rel: index.propTypes.exports.oneOf(['external', 'help', 'license', 'next', 'nofollow', 'noopener', 'noreferrer', 'opener', 'prev', 'search']),
  autoComplete: index.propTypes.exports.oneOf(['on', 'off']),
  formAction: index.propTypes.exports.string
};

exports.Form = Form;
